import React from 'react';
import styled from 'styled-components';

const Badge = styled.span`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  
  ${props => {
    switch (props.status) {
      case 'paid':
        return 'background: rgba(34, 197, 94, 0.2); color: #22c55e;';
      case 'pending':
        return 'background: rgba(251, 191, 36, 0.2); color: #fbbf24;';
      case 'cancelled':
        return 'background: rgba(239, 68, 68, 0.2); color: #ef4444;';
      default:
        return 'background: rgba(156, 163, 175, 0.2); color: #9ca3af;';
    }
  }}
`;

const StatusBadge = ({ status, children }) => {
  return (
    <Badge status={status || 'pending'}>
      {children || status || 'pending'}
    </Badge>
  );
};

export default StatusBadge;

